// extracted by mini-css-extract-plugin
module.exports = {"banner":"x_bN","banner__inner":"x_bP"};